import '../styles/components/cards.css';

const DISCOVERY_LEVELS = [
  { level: 1, label: 'Search', desc: 'Searches company websites and the web by name, company, location, and photo.', cost: '~$0.015', speed: '~5-20s', pipeline: 'Website search → Photo search → Name + Image search' },
  { level: 2, label: 'Result Verification', desc: 'Opens the top LinkedIn result and compares the profile photo to confirm identity.', cost: '~$0.025', speed: '~15-35s', pipeline: 'Website search → Photo search → Name + Image search → Result verification' },
];

const AGE_ESTIMATION_LEVELS = [
  { level: 1, label: 'Website Only', desc: 'Estimates age from company website photos.', cost: '~$0.005', speed: '~3-10s', pipeline: 'Website → Age Detection' },
  { level: 2, label: 'Full Estimation', desc: 'Estimates age from both website and LinkedIn photos for better accuracy.', cost: '~$0.010', speed: '~10-25s', pipeline: 'Website → LinkedIn → Age Detection' },
];

export default function LevelSelector({ mode, level, onLevelChange }) {
  const levels = mode === 'discovery' ? DISCOVERY_LEVELS : AGE_ESTIMATION_LEVELS;

  return (
    <div className="level-cards">
      {levels.map(l => (
        <div
          key={l.level}
          className={`level-card${level === l.level ? ' selected' : ''}`}
          onClick={() => onLevelChange(l.level)}
        >
          <div className={`level-tag l${l.level}`}>Level {l.level}</div>
          <div className="level-name">{l.label}</div>
          <div className="level-desc">{l.desc}</div>
          {l.pipeline && <div className="level-pipeline">{l.pipeline}</div>}
          <div className="level-meta">
            <div className="level-meta-row">
              <span className="level-meta-label">Est. cost</span>
              <span className="level-meta-value">{l.cost}/row</span>
            </div>
            <div className="level-meta-row">
              <span className="level-meta-label">Speed</span>
              <span className="level-meta-value">{l.speed}/row</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
